var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7593 27H19.8796",
    stroke: "#2859C5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1201 27H41.2404",
    stroke: "#2859C5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3658 20.3657C22.0359 18.6956 24.3656 17.9512 27.0001 17.9512C29.6345 17.9512 31.9642 18.6956 33.6344 20.3657C35.3045 22.0359 36.0489 24.3656 36.0489 27C36.0489 29.6345 35.3045 31.9642 33.6344 33.6343C31.9642 35.3045 29.6345 36.0489 27.0001 36.0489C24.3656 36.0489 22.0359 35.3045 20.3658 33.6343C18.6956 31.9642 17.9512 29.6345 17.9512 27C17.9512 24.3656 18.6956 22.0359 20.3658 20.3657ZM46.6561 20.6203C44.8779 20.6203 43.2155 21.1256 42.0005 22.3445C40.7855 23.5595 40.2764 25.2219 40.2764 27C40.2764 28.7782 40.7855 30.4406 42.0005 31.6556C43.2155 32.8745 44.8779 33.3797 46.6561 33.3797C48.4342 33.3797 50.1005 32.8745 51.3155 31.6556C52.5305 30.4406 53.0358 28.7782 53.0358 27C53.0358 25.2219 52.5305 23.5595 51.3155 22.3445C50.0966 21.1256 48.4342 20.6203 46.6561 20.6203ZM7.34407 20.6203C5.56593 20.6203 3.9035 21.1256 2.68464 22.3445C1.46964 23.5595 0.964355 25.2219 0.964355 27C0.964355 28.7782 1.46964 30.4406 2.68464 31.6556C3.9035 32.8745 5.56593 33.3797 7.34407 33.3797C9.12221 33.3797 10.7846 32.8745 11.9996 31.6556C13.2146 30.4406 13.7238 28.7782 13.7238 27C13.7238 25.2219 13.2146 23.5595 11.9996 22.3445C10.7846 21.1256 9.12221 20.6203 7.34407 20.6203Z",
    fill: "#19255B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.951f595c406370c240e1b2b4d2e3a30f.svg";
export { ForwardRef as ReactComponent };